var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.embedded)?_c('div',{staticClass:"start-analysis-cta"},[_c('button',{staticClass:"start-analysis-cta__btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("\n    开始分析\n  ")]),_vm._v(" "),_c('div',{staticClass:"start-analysis-cta__spacer"})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65997fb4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StartAnalysisCta.vue
// module id = null
// module chunks = 